export const QUERY__VIDEOS = 'videos';
export const QUERY__VIDEO_SCHEDULES = 'video-schedules';
export const QUERY__EVENT_TEMPLATES = 'event-templates';
